import React, { useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { N1CommandShow, User } from '../../../types/default-types'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const TeamsReadOnly: React.FC<{
  img: any
  className: any
  expanded: boolean
  onExpand: () => void
  data: N1CommandShow[]
}> = ({ data = [], className, img = [], expanded, onExpand = () => {} }): JSX.Element => {
  const classes = useStyles()

  return (
    <>
      <Box className={classes.teams}>
        <Accordion id="employees" expanded={expanded} onChange={onExpand} square={false}>
          <AccordionSummary expandIcon={<Icon className={className} img={img} />}>Команды</AccordionSummary>
          <AccordionDetails>
            <Box className={className.contentAccordionDetails}>
              <Box className={classes.commandsBox}>
                {data.map((item: N1CommandShow, index: number) => {
                  return (
                    <Box key={`teams-read-only${index}`} className={classes.teamsItem}>
                      <Box className={classes.teamsName}>
                        Команда «{item.nomination.name}»:&nbsp;{item.command.name}
                      </Box>
                      {item.command.users.map((user: User, indexUser: number) => {
                        return (
                          <Box key={`teams-read-only-user${indexUser}`} className={classes.userTeams}>
                            {user.lastName} {user.firstName} {user.middleName}
                          </Box>
                        )
                      })}
                    </Box>
                  )
                })}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  teams: {},
  teamsItem: {
    marginBottom: 30,
    [down('sm')]: {
      marginBottom: 20,
    },
  },
  commandsBox: {
    marginTop: 20,
    fontSize: 18,
    [down('md')]: {
      fontSize: 17,
    },
    [down('sm')]: {
      fontSize: 15,
      marginTop: 15,
    },
  },
  teamsName: {
    color: palette.text.primary,
    fontSize: 18,
    fontWeight: 600,
    [down('md')]: {
      fontSize: 18,
    },
    [down('sm')]: {
      fontSize: 16,
    },
  },
  userTeams: {
    color: palette.text.secondary,
    fontWeight: 500,
    marginTop: 10,
  },
}))
